import {
  CartesianGrid,
  Area,
  AreaChart,
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  Legend,
  XAxis,
  YAxis,
  ReferenceLine,
  ReferenceDot,
  Cell,
  LabelList,
} from "recharts";

import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "../CustomLegend";
import CustomTooltip from "../CustomTooltip";
import PrevTooltip from "../PrevTooltip";
const PrevLegend = ({ selectedYear, indiaValue }) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "10px",
          paddingBottom: "30px",
        }}
      >
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            gap: "20px", // spacing between legend items
            alignItems: "center",
            margin: -100,
          }}
        >
          {/* <li
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "14px",
              fontWeight: "bold",
              color: " #dd1e47",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "12px",
                height: "12px",
                backgroundColor: "#dd1e47",
                borderRadius: "2px", // keep it square-ish
              }}
            ></span>
            <span>Above National baseline</span>
          </li> */}
          {/* <li
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "14px",
              fontWeight: "bold",
              color: " #00a084",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "12px",
                height: "12px",
                backgroundColor: "#00a084",
                borderRadius: "2px", // keep it square-ish
              }}
            ></span>
            <span>Below National baseline</span>
          </li> */}
        </ul>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          marginRight: "100px",
          marginBottom: "10px",
          paddingBottom: "30px",
        }}
      >
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            gap: "20px", // spacing between legend items
            alignItems: "right",
            margin: -100,
          }}
        >
          <li
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "14px",
              fontWeight: "bold",
              color: " #00a084",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "12px",
                height: "12px",
                backgroundColor: "#00a084",
                borderRadius: "2px", // keep it square-ish
              }}
            ></span>
            <span>
              {" "}
              India cumulative value ({selectedYear}) —{" "}
              {indiaValue.toLocaleString()}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

const PWEstimation = ({ data }) => {
  const [showTable, setShowTable] = useState(false);
  const [sortColumn, setSortColumn] = useState("Prevelance_rate");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedYear, setSelectedYear] = useState(2023);
  const highlightStyle = {
    backgroundColor: "#456882",
    color: "#fff",
    fontWeight: "bold",
  };

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const filteredData = data.filter(
    (item) => Number(item.year) === Number(selectedYear),
  );

  const chartDatas = filteredData
    .filter((item) => item.Place !== "INDIA")
    .map((item) => ({
      place: item.Place,
      prevalence_rate: Number(item.Prevalence),
    }));

  // 🔴 Extract INDIA row
  const indiaRow = filteredData.find((item) => item.Place === "INDIA");

  // India value for legend & baseline
  const indiaValue = indiaRow ? Number(indiaRow.Prevalence) : 0;
  // Sorting logic
  const sortedData = [...chartDatas].sort((a, b) => {
    if (sortColumn === "prevalence_rate") {
      return sortOrder === "asc"
        ? a[sortColumn] - b[sortColumn]
        : b[sortColumn] - a[sortColumn];
    }
    return 0; // No sorting for other columns
  });

  // Handle sorting change
  const handleSort = (column) => {
    if (column !== "prevalence_rate") return; // Prevent sorting other columns
    if (sortColumn === column) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };
  return (
    <div style={{ width: "100%", position: "relative" }}>
      {/* Toggle Button */}
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle d-flex align-items-center gap-3">
              <h5>PW Estimation as Per SANKALAK</h5>
              <Form.Select
                size="sm"
                style={{ width: "120px" }}
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
              >
                <option value={2023}>2023</option>
                <option value={2025}>2025</option>
              </Form.Select>
            </div>

            <div class="cardDropDown">
              <span style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </span>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
      {showTable ? (
        <div className="card hptCard mt-4 border-0">
          {/* Table View */}

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold ">STATES</th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("prevalence_rate")}
                  >
                    VALUES{" "}
                    {sortColumn === "prevalence_rate"
                      ? sortOrder === "asc"
                        ? "▲"
                        : "▼"
                      : "⬍"}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr key="row-0">
                  <td style={highlightStyle}>INDIA</td>
                  <td style={highlightStyle}>{indiaValue.toLocaleString()}</td>
                </tr>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td className=" fw-bold ">{item.place}</td>
                    <td>{item.prevalence_rate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        /* Chart View */
        <div className="card hptCard mt-4 border-0">
          <ResponsiveContainer width="100%" height={600}>
            <BarChart
              width={500}
              height={600}
              data={chartDatas}
              margin={{
                top: 10,
                right: 30,
                left: 30,
                bottom: 250,
              }}
            >
              <XAxis
                dataKey="place"
                angle={-90}
                textAnchor="end"
                interval={0}
              />
              <YAxis />
              <Tooltip content={<CustomTooltip />} />
              <Legend
                verticalAlign="top"
                content={
                  <PrevLegend
                    selectedYear={selectedYear}
                    indiaValue={indiaValue}
                  />
                }
              />
              {/* <ReferenceLine y={30191460} stroke="#dd1e47" strokearray="3 3" /> */}
              <Bar
                type="monotone"
                dataKey="prevalence_rate"
                name="PW Estimation as Per SANKALAK"
                fill="#00a084"
              >
                {/* {" "}
                {chartDatas.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      entry.prevalence_rate >= 30191460 ? "#dd1e47" : "#00a084"
                    }
                  />
                ))} */}
                <LabelList
                  dataKey="prevalence_rate"
                  position="top"
                  content={({ x, y, width, value }) => {
                    if (value == null) return null;
                    return (
                      <text
                        x={x + width / 2} // center horizontally
                        y={y - 5} // position slightly above bar
                        fontSize={12}
                        fontWeight="bold"
                        textAnchor="start" // 👈 could also try "middle" for alignment
                        transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                      >
                        {value}
                      </text>
                    );
                  }}
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default PWEstimation;
{
  /* <Legend
  verticalAlign="top"
  formatter={(value) => {
    const aliases = {
      prevalence_rate: "Prevalence Rate (%)",
    };
    return aliases[value] || value;
  }}
/>

<Tooltip
  formatter={(value, name) => {
    const aliases = {
      prevalence_rate: "Prevalence Rate (%)",
    };
    return [value, aliases[name] || name];
  }}
/> */
}
